import React from 'react'
import classes from "./NavItem.module.css"
import { urls } from '../../../Routes/Urls'

function NavItem({children, href, onClick}) {

  const onOptionClick = (e) => {
    if (!e.ctrlKey && !e.metaKey && e.button === 0) {
      // Prevent default only if it's a regular left click
      e.preventDefault();
    }

    onClick()
  }
 return (
    <a className={classes.main} href={href} onClick={(e)=> {e.preventDefault();onClick();}} >{children}</a>
  )
}

export default NavItem